
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as intro9g9E0wLsdX7PKV1McReyDnLp4s_456PIOt4LL1uCOFeU0Meta } from "/vercel/path0/pages/file-a-claim/intro.vue?macro=true";
import { default as reviewkSQupViRjqYG6ryV7gkP8b1adGmkAxUIIIeN4nAnfsgMeta } from "/vercel/path0/pages/file-a-claim/review.vue?macro=true";
import { default as contact_45infoeKd3lOjdPj_45Z_45zCeBPL9veX5mgu7HtCm1CZCmDjC0WEMeta } from "/vercel/path0/pages/file-a-claim/contact-info.vue?macro=true";
import { default as damage_45overview51u1J7nIRLWMpIs6TtLPqTi8uOtjOtuP53f_SVZwqE0Meta } from "/vercel/path0/pages/file-a-claim/damage-overview.vue?macro=true";
import { default as help_45with_45cleanupuB42W3YjiriLF0AX083OKLICL1GdNiZgw_dVD5VF_tQMeta } from "/vercel/path0/pages/file-a-claim/help-with-cleanup.vue?macro=true";
import { default as additional_45detailsU0uAAFTnbg2qIJe2LqdkwWOxPdlSMt8CHGV_URhjzVgMeta } from "/vercel/path0/pages/file-a-claim/additional-details.vue?macro=true";
import { default as details_45and_45attachmentsSkfpeaXTg6mOUcbPCiKl4m6u6fZXmKB0T5EBoP71LpMMeta } from "/vercel/path0/pages/file-a-claim/details-and-attachments.vue?macro=true";
import { default as file_45a_45claimnJpYCsPfSZDb1EhRnlswqiMiZs8Z30P791dj1O_iB70Meta } from "/vercel/path0/pages/file-a-claim.vue?macro=true";
import { default as claim_45submittedvM_455m_45_45NEqgv5yApM_jgLiQOqpXwQDJJNqUZO6QhpZkMeta } from "/vercel/path0/pages/claim-submitted.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "file-a-claim",
    path: "/file-a-claim",
    component: () => import("/vercel/path0/pages/file-a-claim.vue"),
    children: [
  {
    name: "file-a-claim-intro",
    path: "intro",
    component: () => import("/vercel/path0/pages/file-a-claim/intro.vue")
  },
  {
    name: "file-a-claim-review",
    path: "review",
    component: () => import("/vercel/path0/pages/file-a-claim/review.vue")
  },
  {
    name: "file-a-claim-contact-info",
    path: "contact-info",
    component: () => import("/vercel/path0/pages/file-a-claim/contact-info.vue")
  },
  {
    name: "file-a-claim-damage-overview",
    path: "damage-overview",
    component: () => import("/vercel/path0/pages/file-a-claim/damage-overview.vue")
  },
  {
    name: "file-a-claim-help-with-cleanup",
    path: "help-with-cleanup",
    component: () => import("/vercel/path0/pages/file-a-claim/help-with-cleanup.vue")
  },
  {
    name: "file-a-claim-additional-details",
    path: "additional-details",
    component: () => import("/vercel/path0/pages/file-a-claim/additional-details.vue")
  },
  {
    name: "file-a-claim-details-and-attachments",
    path: "details-and-attachments",
    component: () => import("/vercel/path0/pages/file-a-claim/details-and-attachments.vue")
  }
]
  },
  {
    name: "claim-submitted",
    path: "/claim-submitted",
    component: () => import("/vercel/path0/pages/claim-submitted.vue")
  }
]